export const CANCELLATION_POLICY = "Cancellation policy";
export const FUEL_POLICY = "Fuel policy";
